import { Box, Typography } from "@mui/material";
import ProgressBar from "./ProgressBar";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import { CustomCheckbox } from "../Common/CustomCheckbox";
import axiosInstance from "../../utils/config/config";
import { useNavigate } from "react-router-dom";

const interestLabels = {
  jiuJitsu: "Jiu-Jitsu",
  boxing: "Boxing",
  muaythai: "Muay Thai",
  wrestling: "Wrestling",
  kickboxing: "Kickboxing",
  mma: "MMA Training",
  strength: "Strength & Conditioning",
  mental: "Mental & Recovery",
  fighter: "Fighter Lifestyle",
};

const joiningReasonLabels = {
  training: "Training Content",
  tutorials: "Tutorials",
  professionalAccess: "Professionals Access",
  replays: "Replays",
  behindTheScenes: "Behind-the-Scenes",
};

const preferenceLabels = {
  ppvContent: "Pay Per View",
  subscriptionContent: "Subscription",
  freeContent: "Free",
};

const Preferences = ({
  setStep,
  progress,
  setProgress,
  formData,
  setFormData,
}) => {
  const navigate = useNavigate();
  const handleInterestChange = (updatedInterests) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        interests: Object.keys(interestLabels).reduce((acc, key) => {
          acc[key] = updatedInterests.includes(interestLabels[key]);
          return acc;
        }, {}),
      },
    }));
  };

  const finalizeSignUp = async () => {
    try {
      const response = await axiosInstance.post(`/user/finalizeSignUp`, {
        user: formData.user,
      });

      if (response) {
        localStorage.setItem("startTour", "true"); // Store tour trigger
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleJoiningReasonChange = (updatedReasons) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        joiningReason: Object.keys(joiningReasonLabels).reduce((acc, key) => {
          acc[key] = updatedReasons.includes(joiningReasonLabels[key]);
          return acc;
        }, {}),
      },
    }));
  };

  const handlePreferencesChange = (updatedPreferences) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        preferences: Object.keys(preferenceLabels).reduce((acc, key) => {
          acc[key] = updatedPreferences.includes(preferenceLabels[key]);
          return acc;
        }, {}),
      },
    }));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={4}>
      <Box width={{ xs: "90vw", md: "70vw" }}>
        <Typography
          sx={{ fontWeight: "400", fontSize: "32px", mb: 2, textAlign: "left" }}
        >
          Almost Done...
        </Typography>
        <ProgressBar progress={progress} setProgress={setProgress} />
      </Box>

      <Box width={{ xs: "90vw", md: "70vw" }} mt={4}>
        <Typography variant="h6" fontWeight="bold" textAlign="left" mt={3}>
          Subscription Preferences
        </Typography>
        <CustomCheckbox
          options={Object.values(preferenceLabels)}
          selectedValues={Object.keys(formData.user.preferences)
            .filter((key) => formData.user.preferences[key])
            .map((key) => preferenceLabels[key])}
          onChange={handlePreferencesChange}
          multiple
        />

        <Box display="flex" flexDirection="row" gap={5} mt={4}>
          <SecondaryBtn
            text="Previous"
            noIcon
            width="40%"
            onClick={() => setStep(2)}
          />
          <CustomBtn
            text="Next"
            noIcon
            width="40%"
            onClick={() => {
              setProgress(90);
              finalizeSignUp();
              setStep(4);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Preferences;
